<div [@fadeInOut]
     *ngIf="inputIndex >= 0 && form.get([inputName, inputIndex]).hasError(error) && form.get([inputName, inputIndex]).touched"
     translate>{{text}}
</div>

<div [@fadeInOut]
     *ngIf="inputIndex < 0 || !inputIndex  && form.get(inputName).hasError(error) && form.get(inputName).touched"
     >{{ text | translate }}
</div>
